export default __webpack_public_path__ + "6783ef576a6b939724b3d50d3356728e.png";